import {createAction} from '@reduxjs/toolkit'

/** fds 인증 상태를 초기화합니다 */
export const resetFDSProcess = createAction('fds/resetFDSProcess')
